import * as React from "react";
import BaseModal, { BaseModalContent } from "../BaseModal";

const DenyPermitRuleModal=(props)=>{ 
   const {setOpenDenyPermit,openDenyPermit,data} = props;
   
    return(
        <>
            <BaseModal
                title="Alert"
                align="center"
                open={openDenyPermit}
                onClose={setOpenDenyPermit}
                with={500}                
            >
                <BaseModalContent>
                   <p>You are unable to purchase permits because you have unpaid citation(s).</p>
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default DenyPermitRuleModal;